module.exports = __webpack_public_path__ + "static/img/titan-machinery-logo.7fd3ba35.png";